export const IMG = {
  cyberBg: "/img/cyber-bg.jpeg",
  militaryBg: "/img/military-bg.jpeg",
  mapVerdansk: "/img/map-verdansk.jpeg",
  mapRebirth: "/img/map-rebirth.jpeg",
};

export const CONTACT_EMAIL = "gestioneprivateseals@gmail.com";

export const SOCIALS = {
  seals: [
    { label: "Facebook", url: "https://www.facebook.com/share/g/1NqutrviuY/" },
    { label: "Instagram", url: "https://www.instagram.com/seals2020warzone?igsh=MXN6YTBiMnU3bjZ4Zg==" },
    { label: "TikTok", url: "https://www.tiktok.com/@seals_of_warzone?_r=1&_t=ZN-98sOE9vfZag" },
    { label: "Twitch", url: "https://m.twitch.tv/seals2020warzone/home" },
    { label: "YouTube", url: "https://youtube.com/@sealsofwarzone?si=OlnVtYdC1FckSMZG" },
  ],
  saf: [
    { label: "Instagram", url: "https://www.instagram.com/sealsallisforces?igsh=MXQwOXpvcm12ZzN1Mg==" },
    { label: "TikTok", url: "https://www.tiktok.com/@seals.allies.force?_r=1&_t=ZN-98sOH7qfvus" },
  ],
};
